import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Modal, ModalProps } from './Modal';
import { Button } from './Button';
import styled from 'styled-components';

export interface ModalPlatformTourVideoProps {
  show: boolean;
  url: string;
  onClose: () => void;
}

export const ModalPlatformTourVideo: React.FC<ModalPlatformTourVideoProps> = ({
  onClose,
  show,
  url,
}) => {
  const __ = useTranslation().t;

  const onSubmit = () => {
    window.location.href = url;
  };

  const modalProps: ModalProps = {
    show,
    onClose,
    type: 'platform-tour-video',
  };

  return (
    <Modal {...modalProps}>
      <div className="oejr-platform-tour-modal-cover" />
      <div className="oejr-platform-tour-modal-content">
        <Trans
          alt={__('exploreLearnTour')}
          i18nKey="exploreLearnTour"
        >
          <Title>Explore and Learn!</Title>
          <Paragraph>
            Before you start, take a tour of the platform to understand our live classes, how the lessons are structured, and the requirements for unlocking and excelling in the exams for each level.
          </Paragraph>
          <Paragraph>
            By taking the platform tour, you'll uncover a world of possibilities!
          </Paragraph>
        </Trans>
        <Button
          onClick={onSubmit}
          outline
          variant="primary"
          label={__('takePlatformTour')}
          icon="play-circle-regular"
          size="sm"
        />
      </div>
    </Modal>
  );
};

const Title = styled.div`
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.secondary.bold.fontFamily};
`;

const Paragraph = styled.div`
  font-size: 16px;
  line-height: 24px;
`;